import $ from 'jquery';
/* ===============================================================
Form contacts class
=============================================================== */
class Counter {
    // Initialize
    constructor() {
        this.countDowns = $('.irantheme-showcase-counter-countdown');
        this.run();
        this.events();
    }

    // Events
    events() {}

    run() {
        const second = 1000,
            minute = second * 60,
            hour = minute * 60,
            day = hour * 24;

        // Get current class this to access this class in functions
        const objectClass = this;

        this.countDowns.each((index, element) => {
            // Get date value time
            let timeEnd = $(element).attr('data-time-end');
            let timeNow = $(element).attr('data-time-now');
            // Mode of count
            const mode = $(element).data('mode');
            // Calculation
            const countDown = new Date(timeEnd).getTime();
            // Holders of main formats
            let dayFormat, hourFormat, minuteFormat, secondFormat;
            // Holders of temp formats
            let dayTemp, hourTemp, minuteTemp, secondTemp;
            // Increase second for index (Increase time)
            let IncreaseSecond = 1000;

            // Loop from in 1 second
            const counter = setInterval(() => {
                // Get current time
                const now = new Date(timeNow).getTime() + IncreaseSecond;
                // Calc of distance
                const distance = countDown - now;

                if (distance >= 0) {
                    // Calc of days
                    dayTemp = Math.floor(distance / day);
                    if (dayFormat != dayTemp) {
                        dayFormat = dayTemp;

                        // Display count mode
                        let counterElement = $(element).find(
                            '.irantheme-showcase-counter-countdown-list-item-day'
                        );
                        objectClass.mode(mode, counterElement, dayFormat);
                    }

                    // Calc of hours
                    hourTemp = Math.floor((distance % day) / hour);
                    if (hourFormat != hourTemp) {
                        hourFormat = hourTemp;
                        if (hourFormat.toString().length == 1) {
                            hourFormat = `0${hourFormat}`;
                        }

                        // Display count mode
                        let counterElement = $(element).find(
                            '.irantheme-showcase-counter-countdown-list-item-hour'
                        );
                        objectClass.mode(mode, counterElement, hourFormat);
                    }

                    // Calc of minutes
                    minuteTemp = Math.floor((distance % hour) / minute);
                    if (minuteFormat != minuteTemp) {
                        minuteFormat = minuteTemp;
                        if (minuteFormat.toString().length == 1) {
                            minuteFormat = `0${minuteFormat}`;
                        }

                        // Display count mode
                        let counterElement = $(element).find(
                            '.irantheme-showcase-counter-countdown-list-item-minute'
                        );
                        objectClass.mode(mode, counterElement, minuteFormat);
                    }

                    // Calc of seconds
                    secondTemp = Math.floor((distance % minute) / second);
                    if (secondFormat != secondTemp) {
                        secondFormat = secondTemp;
                        if (secondFormat.toString().length == 1) {
                            secondFormat = `0${secondFormat}`;
                        }

                        // Display count mode
                        let counterElement = $(element).find(
                            '.irantheme-showcase-counter-countdown-list-item-second'
                        );
                        objectClass.mode(mode, counterElement, secondFormat);
                    }
                }

                //do something later when date is reached
                if (distance < 0) {
                    $(element)
                        .find('.irantheme-showcase-counter-countdown-caption')
                        .fadeIn(100);
                    // $(element).hide();
                    clearInterval(counter);
                }
                IncreaseSecond += 1000;
            }, 1000);
        });
    }

    // Set mode
    mode(mode, element, formatCounter) {
        // Display count mode
        if (mode == 'normal') {
            $(element).text(formatCounter);
        } else if (mode == 'fade') {
            $(element).fadeOut(500, () => {
                $(element).text(formatCounter).fadeIn(500);
            });
        } else if (mode == 'slide') {
            $(element).slideUp(500, () => {
                $(element).text(formatCounter).slideDown(500);
            });
        }
    }
}

export default Counter;
